<template>
  <div class="accumulation today-alarm">
    <nk-box-title :icon-class="'iconfont icon-duijitu1'" :title="'当月逐日分时段堆积图'">
      <!-- <div slot="title" class="logo"> -->
      <div slot="title">
        <div class="timeDate">
          <span v-for="(item,index) in timeData" :key="index" @click="changeTime(item,index)" :value="item.value" class="time-box dn-title-bg" :class="{'spanColor dn-content-bg':index==isActive }">{{item.value}}
          </span>
        </div>
      </div>
      <div class="content dn-content-bg">
        <div class="box" v-if="isActive != 2">
          <div :id="lineId" class="line1"></div>
        </div>
        <div class="box" v-else>
          <div :id="lineId" class="bigline"></div>
          <div :id="echartsId" class="guan"></div>
        </div>
      </div>
    </nk-box-title>
  </div>
</template>
<script>
import NkBoxTitle from '@/components/common/NkBoxTitle.vue'
import uuidv1 from 'uuid/v1'
import dateTool from '@/utils/dateTool'
import * as utils from '@/utils/index.js'
import api from "../../../../../common/api/index"
import handleData from '@/utils/handleData.js'
import * as fpg from '@/utils/fpg.js'
import { isNull } from 'util'
import { isUndefined } from 'util'
let vm
export default {
  name: 'Accumulation',
  components: { NkBoxTitle },
  props: {
    //   eleData: {
    //     type: Object,
    //     default: () => ({})
    //     },
  },
  data () {
    return {
      timeData: [
        { id: 0, value: '负荷' },
        { id: 1, value: '电流' },
        { id: 2, value: '电量分时段' },
        { id: 3, value: '总用量' },
      ],
      isActive: 0,
      lineId: uuidv1(),
      echartsId: uuidv1(),
      myChart: null,
      guanChart: null,
      //负荷数据
      fhData: {
        x: ['12-13 ', '07-09', '03-14', '12-13', '11-17', '07-22'],
        name: ['负荷'],
        data: [[]],
        color: ['#F68478', '#2FC3D9', '#A1DA24'],
        matchData: [[]],
        title: 'kW',
      },
      //电流数据
      eleData: {
        x: ['12-13 ', '07-09', '03-14', '12-13', '11-17', '07-22'],
        name: ['A相', 'B相', 'C相'],
        data: [[], [], []],
        color: ['#F2B237', '#008000', '#FF0000'],
        matchData: [[], [], []],
        title: 'A',
      },
      //总用电
      totalEle: {
        x: [],
        name: ['昨日', '今日'],
        data: [[], []],
        color: ['#F2B237', '#B4A3E9', '#A1DA24'],
        matchData: [[], []],
        title: 'kW·h',
      },
      //电量分时段
      eleTime: {
        guanData: [
          { value: 3, name: '峰' },
          { value: 2, name: '平' },
          { value: 1, name: '谷' },
        ],
        lineData: {
          x: ['12-13 ', '07-09', '03-14', '12-13', '11-17', '07-22'],
          name: ['峰', '平', '谷'],
          data: [[], [], []],
          color: ['#F46F60', '#39C6DB', '#98D60E'],
          matchData: [],
          title: 'kW·h',
        },
        total: 6,
      },
      measures: [],
      startTime: '', //开始时间
      endTime: '', //结束时间
      measureId: '100000000001',
      pointCode: '100229',
      pointNumber: '0',
      energyType: '1',
      time: 60,
      interTime: null,
    }
  },
  created () {
    vm = this
    let time = new Date()
    vm.startTime = dateTool.format(time, 'yyyy-MM-dd ') + '00:00:00'
    time.setDate(time.getDate() + 1)
    vm.endTime = dateTool.format(time, 'yyyy-MM-dd') + ' 00:00:00'
  },
  mounted () {
    vm.getData(this.fhData)
  },
  methods: {
    changeTime (item, index) {
      vm.isActive = index
    },
    //获取数据
    getData () {
      let vm = this
      let data = []
      let startTime = vm.startTime
      let endTime = vm.endTime
      vm.fhData.x = []
      vm.eleData.x = []
      vm.totalEle.x = []
        ; (vm.eleTime.lineData.x = []), (vm.fhData.matchData = [])
      vm.eleData.matchData = []
        ; (vm.totalEle.matchData = [[]]), []
      vm.eleTime.lineData.matchData = [[], [], []]
      let xData = handleData.createXData('0', startTime, endTime)
      xData.forEach((item) => {
        vm.fhData.x.push(item.title)
        vm.eleData.x.push(item.title)
        vm.totalEle.x.push(item.title)
        vm.eleTime.lineData.x.push(item.title)
      })
      let time = new Date()
      let lastStart = time.setDate(time.getDate() - 1)
      lastStart =
        dateTool.format(new Date(lastStart), 'yyyy-MM-dd ') + '00:00:00' //昨日
      vm.fhData.matchData = utils.getMatchTime(startTime, endTime, 0)
      vm.eleData.matchData = utils.getMatchTime(startTime, endTime, 0)
      vm.totalEle.matchData[0] = utils.getMatchTime(startTime, endTime, 0)
      vm.totalEle.matchData[1] = utils.getMatchTime(lastStart, startTime, 0)
      vm.eleTime.lineData.matchData[0] = utils.getMatchTime(
        startTime,
        endTime,
        0
      )
      vm.eleTime.lineData.matchData[1] = utils.getMatchTime(
        startTime,
        endTime,
        0
      )
      vm.eleTime.lineData.matchData[2] = utils.getMatchTime(
        startTime,
        endTime,
        0
      )
      if (vm.isActive == 0) {
        vm.measures = [
          { measureId: '100000000121', pointNumber: 0, pointCode: '233' },
        ]
        api.quantity
          .getQuantityHour2(vm.measures, vm.startTime, vm.endTime, 0)
          .then((res) => {
            if (res.success) {
              if (vm.interTime) {
                clearTimeout(vm.interTime)
              }
              if (vm.time > 0) {
                vm.interTime = setTimeout(() => {
                  vm.getData()
                }, vm.time * 1000)
              }
              vm.fhData.data = []
              vm.fhData.data.push(
                vm.changeData(
                  res.data[0].data,
                  vm.fhData,
                  vm.fhData.matchData[0]
                ).data
              )
              let initData = vm.initData(vm.fhData)
              vm.filldanline(initData)
            }
          })
      } else if (vm.isActive == 1) {
        vm.measures = [
          { measureId: '100000000121', pointNumber: 0, pointCode: '207' },
          { measureId: '100000000121', pointNumber: 0, pointCode: '208' },
          { measureId: '100000000121', pointNumber: 0, pointCode: '209' },
        ]
        api.measuring
          .getMeasuringValueHour2(vm.measures, vm.startTime, vm.endTime, 0)
          .then((res) => {
            let data
            if (res.success) {
              if (vm.interTime) {
                clearTimeout(vm.interTime)
              }
              if (vm.time > 0) {
                vm.interTime = setTimeout(() => {
                  vm.getData()
                }, vm.time * 1000)
              }
              vm.eleData.data = []
              data = []
              vm.eleData.data.push(
                vm.changeData(res.data[0].data.data, vm.eleData).data
              )
              vm.eleData.data.push(
                vm.changeData(res.data[1].data.data, vm.eleData).data
              )
              vm.eleData.data.push(
                vm.changeData(res.data[2].data.data, vm.eleData).data
              )
              data = vm.eleData
              let initData = vm.initData(data)
              vm.filldanline(initData)
            }
          })
      } else if (vm.isActive == 2) {
        let apiArr = []
        apiArr.push(
          vm.$api.cost.getSpentMoneyHour(
            vm.measureId,
            vm.startTime,
            vm.endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ''
          )
        ) //谷)
        apiArr.push(
          vm.$api.cost.getSpentMoneyHour(
            vm.measureId,
            vm.startTime,
            vm.endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ''
          )
        ) //峰，平，谷。总费)
        Promise.all(apiArr).then((res) => {
          if (vm.interTime) {
            clearTimeout(vm.interTime)
          }
          if (vm.time > 0) {
            vm.interTime = setTimeout(() => {
              vm.getData()
            }, vm.time * 1000)
          }
          fpg.getEcharts(res[0].data, 'pie') //当前时间段的扇形图，
            ; (vm.eleTime.guanData = [
              {
                value: res[0].data.fValue == '-' ? 0 : res[0].data.fValue,
                name: '峰期用电量',
              },
              {
                value: res[0].data.pValue == '-' ? 0 : res[0].data.pValue,
                name: '平期用电量',
              },
              {
                value: res[0].data.gValue == '-' ? 0 : res[0].data.gValue,
                name: '谷期用电量',
              },
            ]),
              (vm.eleTime.total =
                isNull(res[0].data.userValue) ||
                  isUndefined(res[0].data.userValue)
                  ? ''
                  : res[0].data.userValue),
              fpg.getEcharts(res[1].data, 'bar') //当前时间段的柱状图，
          vm.eleTime.lineData.data = [[], [], []]
          vm.eleTime.lineData.matchData[0] = fpg.timeChabge1(
            vm.eleTime.lineData.matchData[0],
            res[1].data,
            'f'
          ) //转换峰数据  //拿当前日的
          vm.eleTime.lineData.matchData[1] = fpg.timeChabge1(
            vm.eleTime.lineData.matchData[1],
            res[1].data,
            'p'
          ) //转换平数据
          vm.eleTime.lineData.matchData[2] = fpg.timeChabge1(
            vm.eleTime.lineData.matchData[2],
            res[1].data,
            'g'
          ) //转换谷数据
          for (let i = 0; i < vm.eleTime.lineData.matchData.length; i++) {
            for (let j = 0; j < vm.eleTime.lineData.matchData[i].length; j++) {
              vm.eleTime.lineData.data[i].push(
                vm.eleTime.lineData.matchData[i][j].value == ''
                  ? '-'
                  : Number(vm.eleTime.lineData.matchData[i][j].value).toFixed(2)
              )
            }
          }
          let initData = vm.initData(vm.eleTime.lineData)
          vm.filldanline(initData)
          vm.fillPie(vm.eleTime)
        })
      } else {
        vm.measures = [
          { measureId: '100000000121', pointNumber: 0, pointCode: '233' },
        ]
        let apiArr = []
        let time = new Date()
        let lastStart = time.setDate(time.getDate() - 1)
        lastStart =
          dateTool.format(new Date(lastStart), 'yyyy-MM-dd ') + '00:00:00' //昨日
        apiArr.push(
          api.quantity.getQuantityHour2(vm.measures, lastStart, vm.startTime, 0)
        )
        apiArr.push(
          api.quantity.getQuantityHour2(
            vm.measures,
            vm.startTime,
            vm.endTime,
            0
          )
        )
        Promise.all(apiArr).then((res) => {
          if (vm.interTime) {
            clearTimeout(vm.interTime)
          }
          if (vm.time > 0) {
            vm.interTime = setTimeout(() => {
              vm.getData()
            }, vm.time * 1000)
          }
          vm.totalEle.data = [[], []]
          vm.totalEle.data[0] = vm.changeDataLittle(
            res[0].data[0].data,
            vm.totalEle.data[0],
            vm.totalEle.matchData[0]
          )
          vm.totalEle.data[1] = vm.changeDataLittle(
            res[1].data[0].data,
            vm.totalEle.data[1],
            vm.totalEle.matchData[1]
          )
          let initData = vm.initData(vm.totalEle)
          vm.filldanline(initData)
        })
      }
    },
    //将拿取的数据进行比较 resData、、接口数据     chartData ecnarta数据  多个  matchData匹配数据
    changeDataLittle (resData, chartData, matchData) {
      let vm = this
      for (let i = 0; i < resData.length; i++) {
        let item = matchData.find((obj) => {
          return obj.time.slice(0, 13) == resData[i].time.slice(0, 13)
        })
        if (item) {
          item.value =
            resData[i].value == '' ? '-' : resData[i].value.toFixed(2)
        }
      }
      return vm.putDataLillte(chartData, matchData)
    },
    //放数据  Data数据  多条  matchData匹配数据
    putDataLillte (Data, matchData) {
      let resData = JSON.parse(JSON.stringify(Data))
      resData.data = []
      matchData.forEach((item) => {
        resData.push(item.value == '' ? '-' : item.value)
      })
      return resData
    },
    //将拿取的数据进行比较 resData、、接口数据     chartData ecnarta数据
    changeData (resData, chartData) {
      let vm = this
      for (let i = 0; i < resData.length; i++) {
        let item = chartData.matchData.find((obj) => {
          return obj.time.slice(0, 13) == resData[i].time.slice(0, 13)
        })
        if (item) {
          item.value =
            resData[i].value == '' ? '-' : resData[i].value.toFixed(2)
        }
      }
      return vm.putData(chartData)
    },
    //放数据  Data数据
    putData (Data) {
      let resData = JSON.parse(JSON.stringify(Data))
      resData.data = []
      resData.matchData.forEach((item) => {
        resData.data.push(item.value == '' ? '-' : item.value)
      })
      return resData
    },
    //格式化需要传入的值
    initData (obj) {
      let newObj = {
        legend: (function () {
          let data = []
          for (let i = 0; i < obj.name.length; i++) {
            data.push(obj.name[i])
          }
          return data
        })(),
        x: obj.x,
        series: (function () {
          let data = []
          for (let i = 0; i < obj.name.length; i++) {
            data.push({
              name: obj.name[i],
              type: 'line',
              data: obj.data[i],
            })
          }
          return data
        })(),
        color: obj.color,
        title: obj.title,
      }
      return newObj
    },
    //柱状图
    filldanline (obj) {
      let this_ = this
      if (
        this_.myChart != null &&
        this_.myChart != '' &&
        this_.myChart != undefined
      ) {
        this_.myChart.dispose()
      }
      this_.myChart = this_.$echarts.init(document.getElementById(this.lineId))
      var option = {
        tooltip: {
          trigger: 'axis',
        },
        // color:["#F68478","#2FC3D9","#A1DA24"],
        color: obj.color,
        grid: {
          containLabel: true,
          left: '20px',
          right: '3%',
          bottom: '10%',
          top: '15%',
        },
        legend: {
          data: obj.legend,
          top: '5%',
          textStyle: {
            color: '#666',
          },
          // itemWidth: 12, // 设置宽度
          // itemHeight: 2, // 设置高度
        },
        xAxis: [
          {
            type: 'category',
            data: obj.x,
            boundaryGap: false,
            // axisTick:{
            //     show:true
            // },
            axisLine: {
              lineStyle: {
                color: '#666',
              },
            },
          },
        ],
        yAxis: {
          type: 'value',
          name: obj.title,
          axisLine: {
            lineStyle: {
              color: '#666',
            },
          },
        },
        series: obj.series,
      }
      this_.myChart.setOption(option, true)
      if (this_.myChart) {
        window.addEventListener('resize', function () {
          this_.myChart.resize()
        })
      }
    },
    //伞形图
    fillPie (eleTime) {
      let data = eleTime.guanData
      vm.guanChart = vm.$echarts.init(document.getElementById(vm.echartsId))
      let option = {
        tooltip: {
          trigger: 'item',
          //   formatter: "{a} <br/>{b}<br/> {c} {{d}%}"
          formatter: '{b}：({d}%)',
        },
        color: ['#F46F60', '#39C6DB', '#98D60E'],
        title: {
          text: '峰平谷用电量',
          textStyle: {
            color: '#3E71FF',
            fontSize: 14,
          },
          subtext: '总计：' + eleTime.total,
          subtextStyle: {
            color: '#666666',
            fontSize: 14,
          },
          left: 'center',
          bottom: '10',
        },
        grid: {
          bottom: '50%',
          left: '7%',
          right: '5%',
          containLabel: true,
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
          },
        },
        series: [
          {
            type: 'pie',
            name: '',
            radius: '65%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
            label: {
              formatter: function (params) {
                let pieName = params.name.split('/').join(' ')
                let num = params.value
                let percent = params.percent
                return pieName + '\n' + num + '\n' + '(' + percent + '%' + ')'
              },
              color: '#000',
              fontWeight: 'bolder',
              position: 'inner',
            },
          },
        ],
      }
      vm.guanChart.setOption(option, true)
      window.addEventListener('resize', function () {
        vm.guanChart.resize()
      })
    },
    resizeEcharts () {
      if (
        this.guanChart != null &&
        this.guanChart != '' &&
        this.guanChart != undefined
      ) {
        this.guanChart.resize()
      }
    },
  },
  watch: {
    isActive (newVal, oldVal) {
      vm.$nextTick(() => {
        vm.getData()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.spanColor {
  color: #1d98ec;
  // background: #fff !important;
}
.accumulation {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  .logo {
    line-height: 25px;
    display: flex;
    flex-flow: row;
    color: rgba(30, 30, 30);
    margin-left: 5px;
    .logoImg {
      margin-right: 5px;
    }
  }
  .timeDate {
    line-height: 38px;
    background: #fff;
    .time-box {
      display: inline-block;
      line-height: 39px;
      padding: 0 12px;
      // background: #0197EE;
    }
  }
  .content {
    display: flex;
    flex: 1;
    flex-flow: column;
    box-sizing: border-box;
    .box {
      display: flex;
      flex: 1;
      .line1 {
        display: flex;
        flex: 1;
        height: 100%;
      }
      .bigline {
        display: flex;
        flex: 5;
        height: 100%;
      }
      .guan {
        display: flex;
        flex: 2;
        height: 100%;
      }
    }
  }
}
</style>
